import { render, staticRenderFns } from "./giftcard.vue?vue&type=template&id=2b04baf6&scoped=true"
import script from "./giftcard.vue?vue&type=script&lang=js"
export * from "./giftcard.vue?vue&type=script&lang=js"
import style0 from "./giftcard.vue?vue&type=style&index=0&id=2b04baf6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b04baf6",
  null
  
)

export default component.exports